import React from 'react';
import G from "../../libs/Glob.mjs";
import LoginForm from "./LoginForm.mjs";
import "./Login.css";

const Login = class extends React.Component {
	constructor(props) {
		super(props);
		const pp = G.getPageParams() || {};
		pp.lang = G.getLanguage();
		this.state = {
			action: G.getPageParam('action') || 'login',
			pp: pp,
		};
		this.uid = G.generateUid('Login');
	}

	componentDidMount() {
		G.register('currentPage', p => {
			const pp = G.clone(p?.params || {} );
			pp.lang = G.getLanguage();
			this.setState({ action: p?.params?.action || 'Login', pp: pp });
		}, this.uid);
		G.register('Prefs', () => {
			const pp = this.state.pp || {};
			pp.lang = G.getLanguage();
			this.setState({pp: pp});
		}, this.uid);
		G.setStatus('pageTitle');
	}

	componentWillUnmount() {
		G.deregister(this.uid);
	}

	render() {
		return <LoginForm { ...this.state.pp }/>;
	}
}

export default Login;